import { Notificacion } from '@components/general/Alertas/Alertas';
import getUnixTimestamp from '@helpers/dates/getUnixTimestamp/getUnixTimestamp';
import { addAgendaAsesoria, getAgendaAsesoriaById, reenviarCorreoFeedback } from '@helpers/httpRequests/httpRequestAgendaAsesorias/httpRequestAgendaAsesorias';
import moment from 'moment';
import React, { useState } from 'react'
import { Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap'

const SolicitarFeedback = ({usuario}) => {
    const {idPerfil, numeroTelefono} = usuario[0];

    const fechaAgenda = getUnixTimestamp();

    const horarioAgenda = moment().format('LT');

    const temaElegido = "Asesoría personalizada";

    const problematica = "Solicitud de asesoría personalizada en temas de paquetería office";

    const [showLoader, setShowLoader] = useState(false);

    const handleFeedback = async() => {
        setShowLoader(true);
        const infoAsesoria = {
            fechaAgenda,
            horarioAgenda,
            temaElegido,
            problematica,
            idPerfil,
            numeroTelefono,
            externa: true
        }

        try{
           const data = await addAgendaAsesoria(infoAsesoria);

            const info = await getAgendaAsesoriaById(data.idAgendaAsesoria);
                        
            const urlVistaPublica = `${window.location.origin}/feedback-asesorias`;

            const url = `${urlVistaPublica}?data=${window.btoa(
                JSON.stringify(info)
            )}`;
            await reenviarCorreoFeedback(info, url);

            Notificacion("success", "Feedback solicitado con éxito");
            
            setShowLoader(false);

        }catch(error){
            console.log("Error al enviar el feedback de asesoría");
            setShowLoader(false);

        }
    }

    const cancelarEnvio = () => {
        Notificacion("info", "No se envió el feedback al usuario");
    }
  return (
    <Container>
        <Row>
            <Col>
                <h2>¿Estás seguro?</h2>
                <p>Se le enviará un correo de feedback por asesoría a <b>{`${usuario[0].nombreCompleto} ${usuario[0].apellidos}`}</b> </p>
            </Col>
        </Row>
        <Row className="mt-3">
            <Col className='d-flex flex-row justify-content-center align-items-center gap-5 p-4'>
                {showLoader ?  <Spinner variant="secondary" /> : (
                    <>
                        <Button className="btn btn-danger" onClick={cancelarEnvio}>Cancelar</Button>
                        <Button className="btn btn-success" onClick={handleFeedback}>Envíar</Button>
                    </>
                )}
                
                
            </Col>
        </Row>
    </Container>
  )
}

export default SolicitarFeedback